/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileSpreadsheet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V22H4zm2 2v16h12V9h-5V4zm9 1.414V7h1.586z" />
        <path d="M7 12h10v7H7zm1 1v1h2v-1zm3 0v1h2v-1zm3 0v1h2v-1zm2 2h-2v1h2zm0 2h-2v1h2zm-3 1v-1h-2v1zm-3 0v-1H8v1zm-2-2h2v-1H8zm3-1v1h2v-1z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileSpreadsheet as FileSpreadsheet };
